import { lazy, Suspense, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
// components
import Loader from "../components/Loader/Loader";
import { ConfigProvider, Layout, theme } from "antd";
import AppSidebar from "../widgets/sideBar";
import AppHeader from "../widgets/header";
import { Content } from "antd/es/layout/layout";
import { FilePlus, FileText, LayoutDashboard } from "lucide-react";
const DashboardContent = lazy(() => import("../views/admin/DashboardContent"));
const VendorregistrationForm = lazy(() =>
  import("../views/admin/VendorregistrationForm")
);

export default function Vendor() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState(
    location.pathname.replace(`/vendor`, "")
  );

const menuItems = [
  {
    key: "/dashboard",
    icon: <LayoutDashboard size={18} />,
    label: "Dashboard",
    path: "/dashboard",
  },
  {
    key: "/invoices",
    icon: <FileText size={18} />,
    label: "Invoices",
    path: "/invoices",
  },
  {
    key: "/submit-invoice",
    icon: <FilePlus size={18} />,
    label: "Create Invoice",
    path: "/submit-invoice",
  },
];

  return (
    <>
      <Suspense fallback={<Loader />}>
        <ConfigProvider
          theme={{
            algorithm: theme.defaultAlgorithm,
            token: {
              colorPrimary: "#0471a3",
              colorBgContainer: "rgba(255, 255, 255, 0.9)",
              borderRadius: 12,
            },
            components: {
              Layout: {
                siderBg: "rgba(255, 255, 255, 0.95)",
                headerBg: "rgba(255, 255, 255, 0.9)",
              },
              Menu: {
                itemBg: "transparent",
                itemSelectedBg: "#0471a3",
                itemSelectedColor: "#ffffff",
                itemHoverBg: "rgba(97, 146, 105, 0.1)",
                itemHoverColor: "#0471a3",
                groupTitleColor: "#8c8c8c",
                groupTitleFontSize: "12px",
              },
            },
          }}
        >
          <Layout style={{ minHeight: "100vh" }}>
            <AppSidebar
              collapsed={collapsed}
              menuItems={menuItems}
              role={"vendor"}
              selectedKeys={selectedKeys}
              setCollapsed={setCollapsed}
              setSelectedKeys={setSelectedKeys}
            />
            <Layout style={{ marginLeft: collapsed ? 80 : 280 }}>
              {/* - - - - - H E A D E R - - - - - */}
              <AppHeader collapsed={collapsed} setCollapsed={setCollapsed} />
              {/* - - - C O N T E N T - - - - - */}
              <Content
                style={{
                  margin: collapsed ? "16px" : "32px",
                  background:
                    "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                  minHeight: "calc(100vh - 144px)",
                  borderRadius: "24px",
                  position: "relative",
                  overflow: "hidden",
                  transition: "all 0.3s ease",
                }}
              >
                {/* Background decoration */}
                <div
                  style={{
                    position: "absolute",
                    top: "-50%",
                    right: "-20%",
                    width: "600px",
                    height: "600px",
                    background:
                      "radial-gradient(circle, rgba(4, 113, 163, 0.03) 0%, transparent 70%)",
                    borderRadius: "50%",
                    zIndex: 0,
                  }}
                />

                <div
                  style={{ position: "relative", zIndex: 1, padding: "40px" }}
                >
                  <Routes>
                    <Route path="/*" element={<DashboardContent />} />
                    <Route
                      path="vendor-registration"
                      element={<VendorregistrationForm />}
                    />
                  </Routes>
                </div>
              </Content>
              {/* - - - F O O T E R - - - - - */}
              {/* <AppFooter /> */}
            </Layout>
          </Layout>
        </ConfigProvider>
      </Suspense>
    </>
  );
}
